import { CONDITION_CASES } from '../store/constants'
import { EXPRESSION_TYPES, INPUT_TYPES } from './bot-json.constants'
import { REGEXES } from '@/utils/key-regex.constants'

class ConditionUtils {

  createConditionJson(conditionCase, expressionValue = null, expressionType = null) {
    if (conditionCase === CONDITION_CASES.OPERATOR_AVAILABLE) {
      return {
        input: INPUT_TYPES.NONE,
        expression: {
          [EXPRESSION_TYPES.OPERATOR_AVAILABLE]: (expressionValue || false)
        }
      }
    }

    if (conditionCase === CONDITION_CASES.DAY) {
      return {
        input: INPUT_TYPES.NONE,
        expression: {
          [EXPRESSION_TYPES.DAYS_OF_WEEK]: (expressionValue || [])
        }
      }
    }

    if (conditionCase === CONDITION_CASES.TIME_BETWEEN) {
      return {
        input: INPUT_TYPES.NONE,
        expression: {
          [EXPRESSION_TYPES.TIME_BETWEEN]: (expressionValue || { from: '08:00', to: '18:00' })
        }
      }
    }

    if (conditionCase === CONDITION_CASES.CHANNEL_TYPE) {
      return {
        input: INPUT_TYPES.CHANNEL_TYPE,
        expression: {
          [EXPRESSION_TYPES.ENUM]: (expressionValue || [])
        }
      }
    }

    if (conditionCase === CONDITION_CASES.BROWSER_URL) {
      return {
        input: INPUT_TYPES.METADATA,
        expression: {
          [EXPRESSION_TYPES.KEY_REGEX]: (
            expressionValue || { key: 'browserUrl', regex: REGEXES.MATCH_EVERYTHING_WITH.source }
          )
        }
      }
    }

    if (conditionCase === CONDITION_CASES.CONTEXT_CHATGPT_CALL_OPERATOR) {
      return {
        input: INPUT_TYPES.CONTEXT,
        expression: {
          [EXPRESSION_TYPES.KEY_EQUALS]: {
            key: 'chatgpt.callOperator',
            equals: 'yes'
          }
        }
      }
    }

    if (conditionCase === CONDITION_CASES.CONTEXT) {
      return {
        input: INPUT_TYPES.CONTEXT,
        expression: {
          [ expressionType || EXPRESSION_TYPES.KEY_EQUALS]: (
            expressionValue || { key: 'apiCall.httpStatus', equals: '200' }
          )
        }
      }
    }

    if (conditionCase === CONDITION_CASES.NO_CONDITION) {
      return {
        input: INPUT_TYPES.NONE,
        expression: {
          [EXPRESSION_TYPES.TRUE]: {}
        }
      }
    }
  }

  getContextPayloadKey(expressionType) {
    return expressionType === EXPRESSION_TYPES.KEY_EQUALS ? 'equals' : 'regex'
  }

}

export default new ConditionUtils()
